import { render, staticRenderFns } from "./CategoryLoading.vue?vue&type=template&id=07b50ad3&name=category-template&"
import script from "./CategoryLoading.vue?vue&type=script&lang=js&"
export * from "./CategoryLoading.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports